<template>
  <ul
    qaid="project-one-bike-selection-card-list"
    class="project-one-bike-selection-card-list grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
  >
    <project-one-bike-selection-card
      v-for="(bike, index) in bikes"
      :key="bike.id"
      :is-selected="index === 0"
      :base-properties="baseProperties"
      :bike="bike"
    />
  </ul>
</template>

<script>
import ProjectOneBikeSelectionCard from '@/projectOne/components/bikeSelectionCards/ProjectOneBikeSelectionCard';
export default {
  components: {ProjectOneBikeSelectionCard},
  props: {
    bikes: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
